// src/services/courseService.js
import api from "./api"

const courseService = {
  // Get all courses
  getCourses: async () => {
    const response = await api.get("/courses")
    return response.data
  },

  // Get course by ID
  getCourseById: async (courseId) => {
    const response = await api.get(`/courses/${courseId}`)
    return response.data
  },

  // Create a new course
  createCourse: async (courseData) => {
    const response = await api.post("/courses", courseData)
    return response.data
  },

  // Update course
  updateCourse: async (courseId, courseData) => {
    const response = await api.patch(`/courses/${courseId}`, courseData)
    return response.data
  },

  // Delete course
  deleteCourse: async (courseId) => {
    const response = await api.delete(`/courses/${courseId}`)
    return response.data
  },
}

export default courseService

